import * as types from "../types";
import { apolloClient } from "@/plugins/apollo";
import {
    GREENHOUSES_QUERY,
    SINGLE_GREENHOUSE_QUERY,
    CREATE_GREENHOUSE_MUTATION,
    UPDATE_GREENHOUSE_MUTATION,
    DELETE_GREENHOUSE_MUTATION,
    UPDATE_GREENHOUSE_DEPARTMENT_LAYOUTS_MUTATION
} from "@/graphql/greenhouses.js";

const state = {
    greenhouses: []
};

const getters = {};

const mutations = {
    [types.SET_GREENHOUSES](state, greenhouses) {
        state.greenhouses = greenhouses;
    },
    [types.SORT_GREENHOUSES](state) {
        state.greenhouses.sort(function(a, b) {
            return a.node.name.toLowerCase() == b.node.name.toLowerCase()
                ? 0
                : a.node.name.toLowerCase() > b.node.name.toLowerCase()
                ? 1
                : -1;
        });
    },
    [types.UPSERT_GREENHOUSE](state, greenhouse) {
        var index = state.greenhouses.findIndex(function(element) {
            return element.node.id == greenhouse.id;
        });

        const node = { node: greenhouse };

        if (index > -1) {
            state.greenhouses.splice(index, 1, node);
        } else {
            state.greenhouses.unshift(node);
        }
    },
    [types.DELETE_GREENHOUSE](state, greenhouse) {
        var index = state.greenhouses.find(function(element, index) {
            if (element.id == greenhouse.id) {
                return index;
            }
        });

        if (index > -1) {
            state.greenhouses.splice(index, 1);
        }
    }
};

const actions = {
    async fetchGreenhouses(context) {
        return new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: GREENHOUSES_QUERY,
                    fetchPolicy: "cache-first"
                })
                .then(response => {
                    // console.log(response);

                    const greenhouses = JSON.parse(
                        JSON.stringify(response.data.greenhouses.edges)
                    );

                    // set
                    context.commit(types.SET_GREENHOUSES, greenhouses);

                    // sort
                    context.commit(types.SORT_GREENHOUSES);

                    resolve(greenhouses);
                })
                .catch(error => {
                    console.log(error);
                    reject(error);
                });
        });
    },

    async fetchSingleGreenhouse(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: SINGLE_GREENHOUSE_QUERY,
                    fetchPolicy: "network-only",
                    variables: {
                        id: payload
                    }
                })
                .then(response => {
                    // deep copy
                    const greenhouse = JSON.parse(
                        JSON.stringify(response.data.greenhouse)
                    );

                    // update store
                    context.commit(types.UPSERT_GREENHOUSE, greenhouse);

                    // sort
                    context.commit(types.SORT_GREENHOUSES);

                    resolve(greenhouse);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async createGreenhouse(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: CREATE_GREENHOUSE_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    // console.log(response);

                    const greenhouse =
                        response.data.createGreenhouse.greenhouse;

                    // update store
                    context.commit(types.UPSERT_GREENHOUSE, greenhouse);

                    // sort
                    context.commit(types.SORT_GREENHOUSES);

                    resolve(greenhouse);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async updateGreenhouse(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: UPDATE_GREENHOUSE_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    // console.log(response);

                    const greenhouse =
                        response.data.updateGreenhouse.greenhouse;

                    // update store
                    context.commit(types.UPSERT_GREENHOUSE, greenhouse);

                    // sort
                    context.commit(types.SORT_GREENHOUSES);

                    resolve(greenhouse);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async deleteGreenhouse(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: DELETE_GREENHOUSE_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    // console.log(response);

                    const greenhouse =
                        response.data.deleteGreenhouse.greenhouse;

                    // update store
                    context.commit(types.DELETE_GREENHOUSE, greenhouse);

                    resolve(greenhouse);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async updateGreenhouseDepartmentLayouts(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: UPDATE_GREENHOUSE_DEPARTMENT_LAYOUTS_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    // console.log(response);

                    const greenhouse =
                        response.data.updateGreenhouseDepartmentLayouts
                            .greenhouse;

                    // update store
                    context.commit(types.UPSERT_GREENHOUSE, greenhouse);

                    // sort
                    context.commit(types.SORT_GREENHOUSES);

                    resolve(greenhouse);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
